var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tobesigned-page" },
    [
      _c("div", { staticClass: "jjr-block" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "jjr" }, [
          _c("div", { staticClass: "rz-block" }, [
            _c("div", { staticClass: "line-block" }, [
              _c("div", { staticClass: "card-text" }, [
                _c("div", { staticClass: "s-font" }, [
                  _vm._v("物业地址:" + _vm._s(_vm.options.adress)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "s-font" }, [
                  _vm._v("户型:" + _vm._s(_vm.options.huxing)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "s-font" }, [
                  _vm._v("面积：" + _vm._s(_vm.options.mianji) + "m²"),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ht-block" }, [
        _c("div", { staticClass: "ht-line" }, [
          _vm._m(1),
          _vm._v(" "),
          !_vm.isSM
            ? _c(
                "div",
                { staticClass: "ht-line-button", on: { click: _vm.goRZ } },
                [_vm._v("去认证")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isSM
            ? _c("div", { staticClass: "ht-line-button-end" }, [
                _vm._v("已认证"),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ht-line" },
          [
            _c("van-uploader", {
              attrs: {
                "after-read": _vm.afterRead,
                "before-delete": _vm.afterDelete,
                multiple: "",
              },
              model: {
                value: _vm.fileList,
                callback: function ($$v) {
                  _vm.fileList = $$v
                },
                expression: "fileList",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ht-line" }, [
          _c("div", { staticClass: "ht-line-text" }, [
            _c(
              "div",
              {
                staticClass: "ht-line-text-title",
                on: {
                  click: function ($event) {
                    return _vm.gopdg()
                  },
                },
              },
              [_vm._v("合同详情")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ht-line-text-content" }, [
              _vm._v("合同编号:" + _vm._s(_vm.options.htbh)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ht-line-text-content" }, [
              _vm._v("签署公司:" + _vm._s(_vm.options.gsgs)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ht-line-text-content" }, [
              _vm._v("成交编号:" + _vm._s(_vm.options.cjbh)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ht-line-text-content" }, [
              _vm._v("签约日期:" + _vm._s(_vm.options.qyrq)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ht-line-text-content" }, [
              _vm._v(
                "\n          经办人:" +
                  _vm._s(_vm.options.qsbm + "/" + _vm.options.jjr_name) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ht-line-text-content" }, [
              _vm._v("签约状态:" + _vm._s(_vm.options.qyzt)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "ht-line-button-end",
                on: {
                  click: function ($event) {
                    return _vm.getHT()
                  },
                },
              },
              [_vm._v("查看合同")]
            ),
            _vm._v(" "),
            _vm.options.tqxh != ""
              ? _c(
                  "div",
                  [
                    _c(
                      "van-uploader",
                      {
                        staticClass: "avatar-uploader",
                        attrs: { "after-read": _vm.afterRead_WTS },
                      },
                      [
                        _vm.WTSUrl == ""
                          ? _c(
                              "div",
                              {
                                staticClass: "ht-line-button",
                                staticStyle: { "margin-top": "0.4rem" },
                              },
                              [_vm._v("上传委托书")]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "ht-line-button-end",
                                staticStyle: { "margin-top": "0.4rem" },
                                attrs: { s: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewWTS()
                                  },
                                },
                              },
                              [_vm._v("委托书已上传")]
                            ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isSM && _vm.options.ssqurl != "" && _vm.options.qssj == ""
              ? _c(
                  "div",
                  {
                    staticClass: "ht-line-button",
                    staticStyle: { "margin-top": "0.4rem" },
                    on: { click: _vm.quQY },
                  },
                  [_vm._v("\n          去签约\n        ")]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "jjr-block-bottom" }, [
        _c("div", { staticClass: "rz-block" }, [
          _c("div", { staticClass: "line-block" }, [
            _c("div", { staticClass: "card-icon" }, [
              _c("img", {
                staticClass: "card-icon-img",
                attrs: {
                  src:
                    _vm.options.jjr_pic == ""
                      ? "../images/avater_default.png"
                      : _vm.options.jjr_pic,
                  alt: "",
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-text" }, [
              _c("div", { staticClass: "lx-font" }, [
                _vm._v(_vm._s(_vm.options.jjr_name)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "s-font" }, [
                _vm._v(_vm._s(_vm.options.qsbm)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-statu" }, [
              _c(
                "a",
                {
                  staticClass: "jinjiren-phone",
                  attrs: { href: "tel:" + _vm.options.jjr_phone },
                },
                [_c("div", { staticClass: "statu-text1" }, [_vm._v("打电话")])]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-statu" }, [
              _c(
                "a",
                {
                  staticClass: "jinjiren-sms",
                  attrs: { href: "sms:" + _vm.options.jjr_phone },
                },
                [_c("div", { staticClass: "statu-text2" }, [_vm._v("在线问")])]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: {
            "show-cancel-button": "",
            "before-close": _vm.beforeClose,
            "confirm-button-text": "确认并同意",
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _vm.company == ""
            ? _c("div", [_c("ComponentA")], 1)
            : _c("div", [_c("ComponentB")], 1),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "jjr-background" }, [
      _c("div", { staticClass: "jjr-pram1" }, [_vm._v("房屋合同进度")]),
      _vm._v(" "),
      _c("div", { staticClass: "jjr-pram2" }, [
        _vm._v("如遇到问题请联系经纪人"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ht-line-text" }, [
      _c("div", { staticClass: "ht-line-text-title" }, [_vm._v("实名认证")]),
      _vm._v(" "),
      _c("div", { staticClass: "ht-line-text-content" }, [
        _vm._v(
          "\n          请首先进行实名认证，确保认证数据为真实数据\n        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ht-line" }, [
      _c("div", { staticClass: "ht-line-text" }, [
        _c("div", { staticClass: "ht-line-text-title" }, [
          _vm._v("上传产权证照片"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ht-line-text-content" }, [
          _vm._v("请确保上传产权证照片为真实数据"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }